// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"673":"date-range-picker","786":"graph"}[chunkId] || chunkId) + "." + {"19":"28a3debc","281":"345c7855","673":"bacaff19","786":"7f963d45","790":"c638d3bb"}[chunkId] + ".chunk.js";
};